export const Constants = {
  PAN_REGEX: /^[a-zA-Z]{3}[CPHFATBLJGcphfatbljg]{1}[a-zA-Z]{1}[0-9]{4}[a-zA-Z]{1}$/,
  EMAIL_REGEX: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  DUMMY: "DUMMY",
  EMPTY: "",
  RUPEE: "\u20B9",

  //Document directories
  NACH: "nach",
  AVATAR: "avatar",
  SELFIE_WITH_PRODUCT: "selfie_with_product",
  CANCELLED_CHEQUE_DIRECTORY: "CANCELLED_CHEQUE",
  PHOTO_WITH_AGENT_NAME: "PHOTO_WITH_AGENT",
  DOWNPAYMENT: "downPayment",

  //Document Names
  PAN_IMAGE_NAME: "PAN",
  DOWNPAYMENT_NAME: "DOWNPAYMENT",
  CANCELLED_CHEQUE_NAME: "CANCELLED_CHEQUE",
  NACH_SIGNED_UNFILLED_NAME: "NACH_SIGNED_UNFILLED",
  NACH_SIGNED_UNFILLED_DIRECTORY: "NACH_SIGNED_UNFILLED",

  //Entity types
  CLIENTS: "clients",
  CLIENTS_IDENTIFIERS : "clientIdentifiers",
  LOANS: "loans",
  STAFF: "staff",
  GROUPS : "groups",
  SAVINGS : "savings",
  SHARES : "shares",
  LOAN_DATA_TABLE : "loandatatables",

  //LoanStage config keys
  BANK_ACCOUNT_TYPE_OPTIONS: "bank.account.type.options",
  PROFESSION_OPTIONS: "profession.options",
  EMI_STAGE_AVAILABLE_DATES: "emi.stage.available.dates",
  CREDIT_INFORMATION_REQUIRED: "credit.information.required",
  BANK_STATEMENT_INSTRUCTIONS: "bank.statement.instructions",

  //Attribute key and name
  EMI_REPAYMENT_KEY: "emi.repayment.date",
  EMI_REPAYMENT_NAME: "Emi Repayment",

  //Loan status
  APPROVED: "Approved",
  ACTIVE: "active",
  REJECTED: "Rejected",
  SUBMITTED_AND_PENDING_APPROVAL: "Submitted and Pending Approval",
  SUBMITTED_TO_FUND: "Submitted to Fund",

  //auth type
  AUTH_TYPE_BASIC: "BASIC",
  AUTH_TYPE_OAUTH: "OAUTH",

  //Perfios transaction types
  UPLOAD_STATEMENT: "UPLOAD_STATEMENT",
  NET_BANKING: "NET_BANKING",

  //image activity types
  AADHAAR_QRSCAN_IMAGE_ACTIVITY: 0x0,
  SELFIE_IMAGE_ACTIVITY: 0x1,
  PAN_CARD_IMAGE_ACTIVITY: 0x2,
  IMEI_NUMBER_IMAGE_ACTIVITY: 0x3,
  GENERIC_DOCUMENT_IMAGE_ACTIVITY: 0x4,
  SERIAL_NUMBER_IMAGE_ACTIVITY: 0x5,
  SELFIE_WITH_PRODUCT_IMAGE_ACTIVITY: 0x6,
  POST_DATED_CHEQUE_IMAGE_ACTIVITY: 0x7,
  PAN_IMAGE_IMAGE_ACTIVITY: 0x8,
  GST_COPY_IMAGE_ACTIVITY: 0x9,
  CANCELLED_CHEQUE_IMAGE_ACTIVITY: 0x10,
  ALTERNATE_PAN_IMAGE_ACTIVITY: 0x11,
  PHOTO_WITH_AGENT: 0x12,
  UPLOAD_PAN: 0x13,

  //Upload to mifos
  DO_NOT_UPLOAD: 0x0,
  UPLOAD: 0x1,

  CODELOOKUP: "CODELOOKUP",
  CODEVALUE: "CODEVALUE",
  CODE_VALUE_SEPARATOR: '_cd_',

  //Kyc
  KYC_DOCUMENT_PURPOSES: ['ADDRESS', 'ID'],
  DOCUMENT_PURPOSE_ADDRESS: 'ADDRESS',
  DOCUMENT_PURPOSE_ID: 'ID',

  //Other Constants
  IMAGE_EXTENSIONS: ['jpg', 'jpeg', 'png', 'tif'],

  //Applicant type
  APPLICANT_TYPE_INDIVIDUAL : "INDIVIDUAL",
  APPLICANT_TYPE_ORGANIZATION : "ORGANIZATION",

  //Company types
  COMPANY_TYPE_INDIVIDUAL : "INDIVIDUAL", //not present in code-values

  //Legal forms type
  LEGAL_FORM_PERSON : "PERSON",
  LEGAL_FORM_ENTITY : "ENTITY",

  //Local storage key names
  LOAN_SCOPE_DATA : "loanScopeData",

  //Entity name
  ENTITY_CLIENT : "CLIENT",
  ENTITY_LOAN : "LOAN",

  //URL
  EZCRED_WEBSITE_URL : "https://www.ezcred.in/",

  //Create client Document types
  DOCUMENT_TYPE_PAN: "PAN",
  DOCUMENT_TYPE_GST: "GST",
  DOCUMENT_TYPE_FORM_60: "FORM_60",

  //Client identifier types
  IDENTIFIER_PAN_CARD: "PAN_CARD",
  IDENTIFIER_GST_NUMBER: "GST_NUMBER",
  IDENTIFIER_FORM_60: "FORM_60",

  //Document Type name
  FORM_60 : "FORM_60",
  PAN : "PAN",
  DEALER_ONBOARDING : "dealer onboarding",


  //EzCredJourneyType ASSISTED,SELF
  EZCRED_JOURNEY_TYPE_ASSISTED: "ASSISTED",
  EZCRED_JOURNEY_TYPE_SELF: "SELF",

  //FORM feilds type
  SELECT : "SELECT",
  INPUT : "INPUT",

  //Input types in stage field data
  DROPDOWN: "DROPDOWN",
  INTEGER: "INTEGER",
  DECIMAL: "DECIMAL",
  DATE: "DATE",
  STRING: "STRING",
  BOOLEAN: "BOOLEAN",
  FILE_UPLOAD: "FILE_UPLOAD",

  //Data tables row events
  DELETE: "delete",
  UPDATE: "update",
  CREATE: "create",

  //CreditEngine apis response statue
  SUCCESS: "SUCCESS",
  FAILURE: "FAILURE",

  //Number of Entries Constraint
  NON_ZERO: "NON_ZERO",
  ONE: "ONE",

  FIELD_CHILD_SEPARATOR: "_CHILD_",

  LOAN_APPLICACTION_TYPE_MAIN: "MAIN",

  //Lender loan key
  LENDER_LOAN_ID: "lender_loan_id",
  LENDER_LOAN_STATUS: "lender_loan_status",

  //Phone codes
  COUNTRY_INDIA_PHONE_CODE: "+91",
  COUNTRY_UAE_PHONE_CODE: "+971",
  COUNTRY_SAUDI_ARABIA_PHONE_CODE: "+966",

  getDescription: key => descriptions[key],

  getIdentifierTypeByIdentifierDocument(identifierDocument) {
    if (!identifierDocument) {
      return "";
    }

    const identifierType = IDENTIFIER_DOCUMENT_TO_IDENTIFIER_TYPE_MAP[identifierDocument];
    return identifierType ? identifierType : identifierDocument;
  },

  getReadableValueForAssociatedEntityType(associatedEntityType) {
    if (!associatedEntityType) {
      return "";
    }
    let readableValue = "";
    Object.keys(AssociatedEntityType).forEach(associatedEntityTypeKey => {
      const associatedEntityDetails =
          AssociatedEntityType[associatedEntityTypeKey];

      if (associatedEntityType === associatedEntityDetails["rawValue"]
          || associatedEntityType === associatedEntityDetails["readableValue"]
      ) {
        readableValue = associatedEntityDetails["readableValue"];
      }
    })

    return readableValue;
  },

  getRawValueForAssociatedEntityType(associatedEntityType) {
    if (!associatedEntityType) {
      return "";
    }
    let rawValue = "";
    Object.keys(AssociatedEntityType).forEach(associatedEntityTypeKey => {
      const associatedEntityDetails =
          AssociatedEntityType[associatedEntityTypeKey];

      if (associatedEntityType === associatedEntityDetails["rawValue"]
          || associatedEntityType === associatedEntityDetails["readableValue"]
      ) {
        rawValue = associatedEntityDetails["rawValue"];
      }
    })

    return rawValue;
  },

  getSeverityLevelDetails(severity) {
    if (!severity) {
      return SeverityLevel.DEFAULT;
    }

    const severityDetails = SeverityLevel[severity];

    return severityDetails ? severityDetails : SeverityLevel.DEFAULT;
  },

  getBureauBandDetails(bureauBand) {
    if (!bureauBand) {
      return BureauBand.DEFAULT;
    }

    const bureauBandDetails = BureauBand[bureauBand];

    return bureauBandDetails ? bureauBandDetails : BureauBand.DEFAULT;
  },
};

const descriptions = {
  nach: "Photo of NACH Form",
  avatar: "Photo of Borrower",
  selfie_with_product: "Customer Image with Product",
  PHOTO_WITH_AGENT: "Photo With Agent",
  PAN: "Pan Card",
  DOWNPAYMENT: "Down Payment Invoice Copy",
  CANCELLED_CHEQUE: "Cancelled Cheque",
  NACH_SIGNED_UNFILLED: "Signed Unfilled NACH Image"
};

const IDENTIFIER_DOCUMENT_TO_IDENTIFIER_TYPE_MAP = {
  PAN: "PAN_CARD",
  FORM_60: "FORM_60",
  GST: "GST_NUMBER",
};

export const AssociatedEntityType = {
  PARENT_LOAN: { rawValue: "PARENT_LOAN", readableValue: "Parent" },
  MAIN: { rawValue: "MAIN", readableValue: "Main" },
  GUARANTOR: { rawValue: "GUARANTOR", readableValue: "Guarantor" },
  CO_APPLICANT: { rawValue: "CO_APPLICANT", readableValue: "Co-Applicant" },
  VERIFICATION: { rawValue: "VERIFICATION", readableValue: "Verification" }
};

export const LoanApplicationType = {
  MAIN: { rawValue: "MAIN", readableValue: "Main" },
  GUARANTOR: { rawValue: "GUARANTOR", readableValue: "Guarantor" },
  CO_APPLICANT: { rawValue: "CO_APPLICANT", readableValue: "Co-Applicant" },
  VERIFICATION: { rawValue: "VERIFICATION", readableValue: "Verification" }
};

export const SeverityLevel = {
  DEFAULT: {
    severity: 100,
    rawValue: "DEFAULT",
    textColor: "#000000",
    backgroundColor: "#ffffff",
    borderColor: "#0060AB"
  },
  LEVEL_ONE: {
    severity: 1,
    rawValue: "LEVEL_ONE",
    textColor: "#ffffff",
    backgroundColor: "#417505",
    borderColor: "#417505"
  },
  LEVEL_TWO: {
    severity: 2,
    rawValue: "LEVEL_TWO",
    textColor: "#ffffff",
    backgroundColor: "#FFA500",
    borderColor: "#FFA500"
  },
  LEVEL_THREE: {
    severity: 3,
    rawValue: "LEVEL_THREE",
    textColor: "#ffffff",
    backgroundColor: "#C5311D",
    borderColor: "#C5311D"
  },
  LEVEL_FOUR: {
    severity: 4,
    rawValue: "LEVEL_FOUR",
    textColor: "#ffffff",
    backgroundColor: "#C5311D",
    borderColor: "#C5311D"
  }
};

export const BureauBand = {
  DEFAULT: {
    rawValue: "DEFAULT",
    textColor: "#000000",
    backgroundColor: "#ffffff",
    borderColor: "#0060AB"
  },
  A: {
    rawValue: "A",
    textColor: "#ffffff",
    backgroundColor: "#417505",
    borderColor: "#417505"
  },
  B: {
    rawValue: "B",
    textColor: "#ffffff",
    backgroundColor: "#FFBF00",
    borderColor: "#FFBF00"
  },
  C: {
    rawValue: "C",
    textColor: "#ffffff",
    backgroundColor: "#C5311D",
    borderColor: "#C5311D"
  },
};


